import { render } from "./landingBooking.vue?vue&type=template&id=4c477d14&scoped=true"
import script from "./landingBooking.vue?vue&type=script&lang=js"
export * from "./landingBooking.vue?vue&type=script&lang=js"

import "./landingBooking.vue?vue&type=style&index=0&id=4c477d14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c477d14"]])

export default __exports__